import { call, fork, put, takeLeading } from 'redux-saga/effects';

import { FETCH_LANGUAGES_REQUEST } from 'constants/ActionTypes';

import { fetchLanguagesSuccess, fetchLanguagesFailure } from '../actions/languageActions';
import LanguageService from '../services/api/LanguageService';

function* fetchLanguagesWatcher() {
  yield takeLeading(FETCH_LANGUAGES_REQUEST, fetchLanguages);
}

function* fetchLanguages() {
  try {
    const response = yield call(LanguageService.getLanguages);
    yield put(fetchLanguagesSuccess(response.data));
  } catch (e) {
    yield put(fetchLanguagesFailure(e));
  }
}

const languageSagas = [fork(fetchLanguagesWatcher)];

export default languageSagas;
